export const CALCULATION_COMMON = 'calculationCommon';

export const CALCULATION_COMMON_ACTIONS_NAME = {
  searchUploadingDataStatus: `${CALCULATION_COMMON}/searchUploadingDataStatus`,
} as const;

export const CALCULATION_COMMON_MUTATIONS_NAME = {
  setUploadingDataStatus: `${CALCULATION_COMMON}/setUploadingDataStatus`,
} as const;

export const CALCULATION_COMMON_GETTERS_NAME = {
  getUploadingDataStatus: `${CALCULATION_COMMON}/getUploadingDataStatus`,
} as const;
